import React from 'react';
import PropTypes from 'prop-types';
import './eventCards.css';

const VideoTestimonialCard = ({
  thumbnail,
  title,
  description,
  onPlay,
  className = '',
  playLabel = 'Play testimonial',
  ...rest
}) => {
  return (
    <article className={`event-card video-testimonial-card ${className}`.trim()} {...rest}>
      <button
        type="button"
        className="video-testimonial-card__media"
        onClick={onPlay}
        aria-label={playLabel}
      >
        {thumbnail && <img src={thumbnail} alt={title} loading="lazy" />}
        <span className="video-testimonial-card__play">
          <i className="fas fa-play" aria-hidden="true"></i>
        </span>
      </button>
      {/* If title is a URL, render as clickable link, else as plain text. Truncate with CSS. */}
      <p className="video-testimonial-card__title">
        {typeof title === 'string' && title.trim().match(/^https?:\/\//i)
          ? (
              <a
                href={title.trim()}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2c2c2c', textDecoration: 'underline', wordBreak: 'break-all', display: 'inline-block', maxWidth: '100%' }}
                title={title.trim()}
              >
                {title.trim()}
              </a>
            )
          : (typeof title === 'string'
              ? title.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim()
              : title)
        }
      </p>
      {description && (
        <p className="video-testimonial-card__desc" style={{
          fontSize: '13px',
          color: '#444',
          marginTop: '2px',
          textAlign: 'center',
          minHeight: '18px',
          lineHeight: '1.2',
        }}>{description}</p>
      )}
    </article>
  );
};

VideoTestimonialCard.propTypes = {
  thumbnail: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onPlay: PropTypes.func,
  className: PropTypes.string,
  playLabel: PropTypes.string,
};

VideoTestimonialCard.defaultProps = {
  thumbnail: '',
  description: '',
  onPlay: () => {},
  className: '',
  playLabel: 'Play testimonial video',
};

export default VideoTestimonialCard;



